var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.formOption.busy } },
    [
      _c(
        "a-form",
        {
          ref: "form",
          attrs: {
            form: _vm.form,
            "label-col": { span: 12 },
            "wrapper-col": { span: 12 },
          },
        },
        [
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 20 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "标签名称" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["tagName", _vm.rules.tagName],
                            expression: "['tagName',rules.tagName ]",
                          },
                        ],
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 20 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "标签类型" } },
                    [
                      _c("a-select", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["tagTypeId", _vm.rules.tagTypeId],
                            expression: "['tagTypeId',rules.tagTypeId]",
                          },
                        ],
                        attrs: {
                          allowClear: true,
                          options: _vm.tagType,
                          disabled: _vm.show,
                        },
                        on: { change: _vm.changeType },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 20 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "标签分组" } },
                    [
                      _c("a-select", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["tagGroupId", _vm.rules.tagGroupId],
                            expression: "['tagGroupId',rules.tagGroupId]",
                          },
                        ],
                        attrs: {
                          allowClear: true,
                          options: _vm.groupTwoList,
                          disabled: _vm.show,
                        },
                        on: { change: _vm.changeGroupType },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-space",
        { staticClass: "a-form-btn-box" },
        [
          _c(
            "a-button",
            {
              on: {
                click: function ($event) {
                  return _vm.endEdit("cancelled")
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "a-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm._save(false)
                },
              },
            },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }